import React from 'react';

import { ENTITY_INVITE_DIRECTOR_MODAL_DESCRIPTION, ENTITY_INVITE_DIRECTOR_MODAL_TITLE } from 'constants/entities';
import { ButtonVariants } from 'constants/shared/button';
import { TypographyVariants } from 'constants/shared/typography';
import useModal from 'hooks/use-modal/useModal';
import { selectUser } from 'modules/current-user/selectors';
import { useAppSelector } from 'modules/store';
import { Button, ModalWindow, TitleWithDescription } from 'shared-components';

import { EntityInviteDirectorForm } from '../index';
import EntityInvestorsList from './EntityInvestorsList';

const EntityInvestors = () => {
  const currentUser = useAppSelector(selectUser);
  const companyId = currentUser?.entityCompany?.id;

  const {
    onOpen: onOpenInvitePreviewModal,
    onClose: onCloseInvitePreviewModal,
    ...invitePreviewModalState
  } = useModal();

  return (
    <>
      <ModalWindow
        title={ENTITY_INVITE_DIRECTOR_MODAL_TITLE}
        description={ENTITY_INVITE_DIRECTOR_MODAL_DESCRIPTION}
        titleVariant={TypographyVariants.MEDIUM}
        headerClassName='text-blue-800'
        className='min-w-[70%] 2xl:min-w-[1048px]'
        contentClassName='overflow-x-hidden'
        onClose={onCloseInvitePreviewModal}
        {...invitePreviewModalState}
      >
        <EntityInviteDirectorForm onModalClose={onCloseInvitePreviewModal} />
      </ModalWindow>
      <div className='flex flex-col gap-4 mt-6 mb-4'>
        <div className='flex justify-between flex-col sm:flex-row'>
          <TitleWithDescription className='flex-1' title='Investors' />
          <Button
            className='w-full sm:w-auto self-center'
            onClick={onOpenInvitePreviewModal}
            variant={ButtonVariants.SECONDARY}
          >
            Send Invite
          </Button>
        </div>

        <EntityInvestorsList companyId={Number(companyId)} />
      </div>
    </>
  );
};

export default EntityInvestors;
